/**
 * Skogstad Sport – nedtelling til VIP-kampanjen slutter (okt. 2026)
 * ---------------------------------------------------------------------------
 * Brukes av:
 *   sections/skogstad-vip-stripe.liquid      kort:   «Slutter om 2 d 14 t 32 min»
 *                                            klokke: «Siste dag – slutter om 09:44:05»
 *   sections/skogstad-vip-steg.liquid        ledd:   2 DAGER | 14 TIMER | 32 MINUTTER
 *   snippets/skogstad-vip-hero-nedtelling    ledd + sekunder alltid: 09 : 44 : 05
 *   snippets/skogstad-vip-pdp.liquid         klokke: «Siste dag – slutter om 09:44:05»
 *
 * Sluttiden kommer fra snippets/skogstad-vip-slutt.liquid (data-slutt, Unix-
 * sekunder i UTC), så alle ser samme øyeblikk uansett tidssone.
 *
 * ---------------------------------------------------------------------------
 * HVA SOM VISES
 *
 * Standard (kort, ledd):
 *   Mer enn ett døgn igjen  →  dager, timer, minutter
 *   Under ett døgn          →  timer, minutter
 *   Siste time              →  minutter, sekunder
 *
 * data-sekunder="alltid" (heroen siste dag, 18.10): timer, minutter og
 * sekunder hele tiden, to sifre, som en klokke – dager foran hvis det er
 * mer enn ett døgn igjen.
 *
 * data-format="klokke": samme som over, som én tekst: «09:44:05».
 *
 * ---------------------------------------------------------------------------
 * NÅR KLOKKA TREFFER NULL
 *
 * Nærmeste [data-sk-vip-skjul] skjules (stripa, nedtellingsraden, heroboksen,
 * linja på produktsiden). Det skjer også hvis siden lastes etter sluttiden,
 * f.eks. en bufret side fra Shopify – det er hullet snippets/skogstad-vip-aktiv
 * ikke kan tette, fordi Liquid bare vet når siden sist ble rendret.
 *
 * Før skriptet har kjørt står tallene usynlige (klassen sk-vip-ned--venter,
 * visibility: hidden) men tar plass, så ingenting hopper når tallene kommer.
 */

(function () {
  'use strict';

  if (window.skVipNedtelling) return;
  window.skVipNedtelling = true;

  var VELGER = '[data-sk-vip-nedtelling]';
  var VENTER = 'sk-vip-ned--venter';
  var aktive = [];
  var intervall = null;

  function tosifret(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // Rundes opp, så klokka viser «1 s» det siste sekundet og når null
  // nøyaktig når tiden er ute.
  function tid(igjenMs) {
    var s = Math.max(0, Math.ceil(igjenMs / 1000));
    return {
      d: Math.floor(s / 86400),
      t: Math.floor((s % 86400) / 3600),
      m: Math.floor((s % 3600) / 60),
      s: s % 60
    };
  }

  // Hvilke ledd som vises, og med hvilke tall.
  function deler(igjenMs, alltidSekunder) {
    var x = tid(igjenMs);
    if (alltidSekunder) {
      var liste = [['timer', x.t], ['minutter', x.m], ['sekunder', x.s]];
      if (x.d > 0) liste.unshift(['dager', x.d]);
      return liste;
    }
    if (x.d > 0) return [['dager', x.d], ['timer', x.t], ['minutter', x.m]];
    if (x.t > 0) return [['timer', x.t], ['minutter', x.m]];
    return [['minutter', x.m], ['sekunder', x.s]];
  }

  function Nedtelling(rot) {
    this.rot = rot;
    this.slutt = parseInt(rot.getAttribute('data-slutt'), 10) * 1000;
    this.format = rot.getAttribute('data-format') || 'kort';
    this.alltid = rot.getAttribute('data-sekunder') === 'alltid' || this.format === 'klokke';
    this.skjul = rot.closest('[data-sk-vip-skjul]') || rot;
    this.sist = '';

    if (isNaN(this.slutt)) {
      // Ugyldig sluttid: vis ingenting heller enn feil tall.
      rot.hidden = true;
      return;
    }

    if (this.format === 'kort') {
      var enheter = (rot.getAttribute('data-enheter') || 'd,t,min,s').split(',');
      this.enheter = {
        dager: (enheter[0] || 'd').trim(),
        timer: (enheter[1] || 't').trim(),
        minutter: (enheter[2] || 'min').trim(),
        sekunder: (enheter[3] || 's').trim()
      };
      this.felt = rot.querySelector('[data-tid]') || rot;
    } else if (this.format === 'klokke') {
      this.felt = rot.querySelector('[data-tid]') || rot;
    } else {
      this.ledd = {};
      var li = rot.querySelectorAll('[data-ledd]');
      for (var i = 0; i < li.length; i++) {
        this.ledd[li[i].getAttribute('data-ledd')] = {
          rot: li[i],
          tall: li[i].querySelector('[data-tall]')
        };
      }
    }

    this.ferdig = false;
    this.tegn();
    aktive.push(this);
  }

  Nedtelling.prototype.skriv = function (tekst) {
    if (tekst !== this.sist) {
      this.felt.textContent = tekst;
      this.sist = tekst;
    }
  };

  Nedtelling.prototype.tegn = function () {
    if (this.ferdig) return;

    var igjen = this.slutt - Date.now();
    if (igjen <= 0) {
      this.ferdig = true;
      this.skjul.hidden = true;
      return;
    }

    if (this.format === 'klokke') {
      var x = tid(igjen);
      this.skriv((x.d > 0 ? x.d + ' d ' : '') + tosifret(x.t) + ':' + tosifret(x.m) + ':' + tosifret(x.s));
    } else if (this.format === 'kort') {
      var enheter = this.enheter;
      var liste = deler(igjen, this.alltid);
      // Siste minutt: «45 s», ikke «0 min 45 s».
      if (!this.alltid && liste.length > 1 && liste[0][1] === 0) liste = liste.slice(1);
      this.skriv(liste.map(function (del) {
        var tall = del[0] === 'sekunder' ? tosifret(del[1]) : String(del[1]);
        return tall + ' ' + enheter[del[0]];
      }).join(' '));
    } else {
      var ledd = deler(igjen, this.alltid);
      var vis = {};
      for (var i = 0; i < ledd.length; i++) {
        var navnI = ledd[i][0];
        // Dager står alltid som det er. Resten får to sifre når noe står
        // foran dem – og alltid i klokkemodus, så «09 : 44 : 05» ikke hopper.
        vis[navnI] = navnI === 'dager' || (i === 0 && !this.alltid) ? String(ledd[i][1]) : tosifret(ledd[i][1]);
      }
      for (var navn in this.ledd) {
        if (!Object.prototype.hasOwnProperty.call(this.ledd, navn)) continue;
        var l = this.ledd[navn];
        var synlig = Object.prototype.hasOwnProperty.call(vis, navn);
        if (l.rot.hidden === synlig) l.rot.hidden = !synlig;
        if (synlig && l.tall && l.tall.textContent !== vis[navn]) {
          l.tall.textContent = vis[navn];
        }
      }
    }

    this.rot.classList.remove(VENTER);
  };

  function tegnAlle() {
    var igjen = false;
    for (var i = 0; i < aktive.length; i++) {
      aktive[i].tegn();
      if (!aktive[i].ferdig) igjen = true;
    }
    if (!igjen) stopp();
  }

  function start() {
    if (intervall || !aktive.length) return;
    intervall = window.setInterval(tegnAlle, 1000);
  }

  function stopp() {
    window.clearInterval(intervall);
    intervall = null;
  }

  function finn(omraade) {
    var noder = (omraade || document).querySelectorAll(VELGER);
    for (var i = 0; i < noder.length; i++) {
      if (noder[i].skVipNedtelling) continue;
      noder[i].skVipNedtelling = new Nedtelling(noder[i]);
    }
    start();
  }

  // En telefon som har ligget i lomma skal vise riktig tall med en gang.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stopp();
    } else {
      tegnAlle();
      start();
    }
  });

  // Temaeditoren rendrer seksjoner på nytt når innstillinger endres.
  document.addEventListener('shopify:section:load', function (e) {
    finn(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { finn(); });
  } else {
    finn();
  }
})();
